console.log('🚀 Starting Vue app initialization...')

// Use static imports (not dynamic) - Vite handles these correctly
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import en from './i18n/en.js'
import de from './i18n/de.js'
import './assets/main.css'

// Wrap the rest in try-catch
try {

    // Safely get locale from localStorage
    let savedLocale = 'en'
    try {
        savedLocale = localStorage.getItem('locale') || 'en'
        console.log('✅ Locale loaded:', savedLocale)
    } catch (e) {
        console.warn('⚠️ localStorage not available, using default locale')
    }

    console.log('📦 Creating i18n instance...')
    const i18n = createI18n({
        legacy: false,
        locale: savedLocale,
        fallbackLocale: 'en',
        messages: {
            en,
            de
        }
    })
    console.log('✅ i18n created')

    // Create the app instance
    console.log('📦 Creating Vue app instance...')
    const app = createApp(App)
    console.log('✅ Vue app instance created')

    // Set global API base URL
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000'
    app.config.globalProperties.$apiBaseUrl = apiBaseUrl
    console.log('✅ API base URL set:', apiBaseUrl)

    // Use plugins
    console.log('📦 Registering plugins...')
    app.use(i18n)
    console.log('✅ i18n plugin registered')
    app.use(router)
    console.log('✅ router plugin registered')

    // Global error handler
    app.config.errorHandler = (err, vm, info) => {
        console.error('Global error:', err)
        console.error('Error info:', info)
        console.error('Error stack:', err?.stack)
    }

    // Mount the app
    const appElement = document.getElementById('app')
    if (!appElement) {
        throw new Error('App element not found!')
    }
    
    app.mount('#app')
    console.log('✅ Vue app mounted successfully!')
  
} catch (error) {
    console.error('❌ CRITICAL ERROR:', error)
    console.error('Error message:', error.message)
    console.error('Error stack:', error.stack)
    
    const appElement = document.getElementById('app')
    if (appElement) {
      const errorMsg = error.message || 'Unknown error'
      const errorStack = error.stack || 'No stack trace available'
      
      appElement.innerHTML = `
        <div style="padding: 30px; background: red; color: white; font-family: Arial, sans-serif; font-size: 18px; line-height: 1.6;">
          <h1 style="color: white; margin: 0 0 20px 0; font-size: 32px;">❌ ERROR LOADING APP</h1>
          <div style="background: #8B0000; padding: 15px; border-radius: 5px; margin: 20px 0;">
            <p style="margin: 0; font-size: 20px; font-weight: bold;">Error Message:</p>
            <p style="margin: 10px 0 0 0; font-size: 16px; word-break: break-word;">${errorMsg}</p>
          </div>
          <details style="margin-top: 20px;">
            <summary style="cursor: pointer; font-size: 16px; margin-bottom: 10px;">Click to see full error details</summary>
            <pre style="background: #333; padding: 15px; overflow: auto; max-height: 400px; font-size: 12px; border-radius: 5px; margin-top: 10px;">${errorStack}</pre>
          </details>
          <p style="margin-top: 20px; font-size: 16px;">Please copy the error message above and share it.</p>
        </div>
      `
      
      // Also alert for visibility
      alert('ERROR: ' + errorMsg + '\n\nCheck the red box on the page for details.')
    }
}
